import { faImages } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";
import { ImageGenerationPage } from "./ImageGenerationPage";

export const imageGenerationFeature: IFeature = {
  id: Features.ImageGeneration,
  route: {
    path: RouteConstants.ImageGeneration,
    element: (
      <FeatureGuard role={AppRole.ImageGenerationFeature}>
        <ImageGenerationPage />
      </FeatureGuard>
    ),
  },
  menuItem: {
    label: translationKeys.feature.imageGeneration.link,
    breadCrumbTitle: translationKeys.feature.imageGeneration.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.ImageGeneration].join("/")}`,
    path: RouteConstants.ImageGeneration,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faImages} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.ImageGeneration}
      requiresBudget={true}
      featureIcon={faImages}
      buttonIcon={faImages}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.ImageGeneration}
    />
  ),
  role: AppRole.ImageGenerationFeature,
};
